<template>
  <div class="create-project-form">
    <el-dialog
      :title="'Create project'"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :before-close="handleClose"
      :width="device === 'mobile' ? '80%' : '50%'"
    >
      <el-form
        :model="projectForm"
        id="projectForm"
        ref="projectForm"
        label-width="200px"
        size="small"
        :rules="projectFormRules"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-form-item label="Distribution code" prop="distribution_code">
          <el-input
            v-model="projectForm.distribution_code"
            autocomplete="off"
            readonly="readonly"
          ></el-input>
        </el-form-item>
        <el-form-item label="Prefix code" prop="prefix_code">
          <el-input
            v-model="projectForm.prefix_code"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Project Name" prop="project_name">
          <el-input
            v-model="projectForm.project_name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Discription" prop="discription">
          <el-input type="textarea" :rows="2" v-model="projectForm.discription">
          </el-input>
        </el-form-item>

        <el-form-item label="Pricing control by" prop="pricingby">
          <el-select v-model="projectForm.pricingby" placeholder="Select Pricing control">
            <el-option  label="ABBS"  value="abbs"></el-option>
            <el-option  label="Data System"  value="ds"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="Fee Control By" prop="feeby">
          <el-select v-model="projectForm.feeby" placeholder="Select Fee Control By">
            <el-option  label="ABBS"  value="abbs"></el-option>
            <el-option  label="Data System"  value="ds"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Webhook bank" prop="webhook_bank">
          <el-input
            v-model="projectForm.webhook_bank"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook bank key" prop="webhook_bank_key">
          <el-input
            v-model="projectForm.webhook_bank_key"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook transaction" prop="webhook_transaction">
          <el-input
            v-model="projectForm.webhook_transaction"
          ></el-input>
        </el-form-item>

        <el-form-item label="Webhook transaction key" prop="webhook_transaction_key">
          <el-input
            v-model="projectForm.webhook_transaction_key"
          ></el-input>
        </el-form-item>

        <el-form-item label="Account Limit By Currency" prop="accountLimitBycurrency">
          <el-input
            v-model="projectForm.accountLimitBycurrency"
          ></el-input>
        </el-form-item>

        <el-form-item label="User Role">
          <el-checkbox-group v-model="projectForm.user">
            <el-checkbox
              v-for="item in userData"
              :label="item.uid"
              :key="item.uid"
              >{{ `${item.role} - ${item.email}` }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="submiting" type="primary" @click="submitProject()"
          >Submit</el-button
        >
        <el-button @click="handleClose">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  createProject,
  getDistributionCode,
} from "@/api/project";
import { getUserByCompany } from "@/api/user";
export default {
  props: {
    dialogShow: Boolean,
    companyUID: String,
  },
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      submiting: false,
      errMsg: "",
      userData: [],
      projectForm: {
        uid: "",
        project_name: "",
        distribution_code: "",
        prefix_code: "",
        discription: "",
        pricingby: "abbs",
        feeby: "abbs",
        webhook_bank: "",
        webhook_bank_key: "",
        webhook_transaction: "",
        webhook_transaction_key: "",
        accountLimitBycurrency: "",
        user: [],
      },
      projectFormRules: {
        project_name: [
          {
            required: true,
            message: "Please enter Project Name",
            trigger: "blur",
          },
        ],
        prefix_code: [
          {
            required: true,
            message: "Please enter prefix code",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    getUserByCompanyData() {
      getUserByCompany(this.companyUID).then(({ result, data }) => {
        if (result) {
          this.userData = data;
        }
      });
    },
    getDistributionCode() {
      const loading = this.$notifyloading("Loading data...");
      getDistributionCode().then(({ result, data }) => {
        loading.close();
        if (result) {
          this.projectForm.distribution_code = data.code;
        }
      });
    },
    mapData(){
      const formData = {
        project_name: this.projectForm.project_name,
        distribution_code: this.projectForm.distribution_code,
        discription: this.projectForm.discription,
        pricingby: this.projectForm.pricingby,
        feeby: this.projectForm.feeby,
        prefix_code: this.projectForm.prefix_code,
        user_uid: this.projectForm.user.join(','),
        webhook_bank: this.projectForm.webhook_bank,
        webhook_bank_key: this.projectForm.webhook_bank_key,
        webhook_transaction: this.projectForm.webhook_transaction,
        webhook_transaction_key: this.projectForm.webhook_transaction_key,
        accountLimitBycurrency: parseInt(this.projectForm.accountLimitBycurrency) || 0
      }
      return formData
    },
    createProject(){
      const formData = this.mapData()
      this.submiting = true
      this.errMsg = ''
      createProject(this.companyUID, formData).then(({ result, message}) =>{
        this.submiting = false
        if(result){
          this.$notify({
            title: 'Success',
            message: `Create Project successfully`,
            type: 'success',
            duration: 2000
          });
          this.handleClose()
          this.$emit("on-submited", true);
        }else{
          this.errMsg = message
        }
      })
    },
    submitProject(){
      
      this.$refs.projectForm.validate((valid) => {
        if(valid){
          this.createProject()
        }else{
          console.log('error submit!!')
          return false
        }
      });
    },
    resetForm() {
      if(this.$refs.projectForm) this.$refs.projectForm.resetFields()
    },
    handleClose() {
      this.$emit("update:dialog-show", false);
    },
  },
  created() {
    this.getUserByCompanyData();
    this.getDistributionCode();
  },
};
</script>

<style>
</style>